'use strict';

import template from './dealerPhoneCta.template.html';
import controller from './dealerPhoneCta.controller.js';

const component = {
    bindings: {
        carsTrackingDtm : '@',
        dealerPhoneNumber : '@',
        stockTypeCode: '@',
        sellerId: '@',
        listingId: '@'
    },
    controller,
    template
};

export default component;
